import type { PriceSummaryRow, MoneyPair } from '@/pages/quotation-design/types';
import DualCurrencyMoney from '@/components/base/DualCurrencyMoney';

export default function QuoteTotals({ rows }: { rows: PriceSummaryRow[] }) {
  return (
    <div className="px-6 md:px-9 mt-8 flex justify-end">
      <div className="w-full sm:w-[360px] md:w-[400px] border border-ink-100 rounded-lg overflow-hidden">
        {rows.map((r) => {
          if (r.total) {
            return (
              <div
                key={r.label}
                className="flex items-center justify-between px-5 py-4 bg-ink-700"
              >
                <span className="text-sm font-bold text-white tracking-wide">{r.label}</span>
                {typeof r.value === 'string' ? (
                  <span className="text-base font-extrabold text-white tabular-nums">{r.value}</span>
                ) : (
                  <DualCurrencyMoney
                    usdAmount={(r.value as MoneyPair).usd}
                    selectedAmount={(r.value as MoneyPair).selected}
                    selectedCurrency={(r.value as MoneyPair).currency}
                    preserveUsdPrecision={(r.value as MoneyPair).unitPrice}
                    secondaryPosition="inline"
                    primaryClassName="text-base font-extrabold text-white"
                    secondaryClassName="text-xs font-normal text-white/70"
                  />
                )}
              </div>
            );
          }
          return (
            <div
              key={r.label}
              className={`flex items-center justify-between px-5 py-2.5 ${
                r.strong ? 'bg-cream-50/60' : ''
              }`}
            >
              <span
                className={`text-sm ${
                  r.strong ? 'font-semibold text-ink-700' : 'text-ink-500'
                }`}
              >
                {r.label}
              </span>
              {typeof r.value === 'string' ? (
                <span className="text-sm tabular-nums text-ink-600">{r.value}</span>
              ) : (
                <DualCurrencyMoney
                  usdAmount={(r.value as MoneyPair).usd}
                  selectedAmount={(r.value as MoneyPair).selected}
                  selectedCurrency={(r.value as MoneyPair).currency}
                  preserveUsdPrecision={(r.value as MoneyPair).unitPrice}
                  secondaryPosition="inline"
                  primaryClassName={`text-sm ${
                    r.strong ? 'font-semibold text-ink-700' : 'text-ink-600'
                  }`}
                  secondaryClassName="text-xs font-normal text-ink-400"
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}